'use strict';

var $ = require('../internals/export');

var createHTML = require('../internals/create-html');

var forcedStringHTMLMethod = require('../internals/forced-string-html-method'); // `String.prototype.big` method
// https://tc39.github.io/ecma262/#sec-string.prototype.big


$({
  target: 'String',
  proto: true,
  forced: forcedStringHTMLMethod('big')
}, {
  big: function big() {
    return createHTML(this, 'big', '', '');
  }
});